import React from 'react';
import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// Small building blocks shared by the detail dialogs of the Endpoint Devices page.

export const orDash = (v) => (v === null || typeof v === 'undefined' || v === '' ? '-' : String(v));

// "Label  value" lines for one block of the detail view.
export function InfoBlock({ title, rows }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{title}</Typography>
      {rows.map(([label, value]) => (
        <Stack key={label} direction="row" spacing={1} sx={{ py: 0.25 }}>
          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 150 }}>{label}</Typography>
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{orDash(value)}</Typography>
        </Stack>
      ))}
    </Paper>
  );
}

// A plain scrollable table for the update lists (can be long).
export function ListTable({ title, columns, rows }) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 700 }}>
        {title} ({rows.length})
      </Typography>
      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary">None.</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 320 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map(c => <TableCell key={c.key} sx={{ fontWeight: 700 }}>{c.label}</TableCell>)}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                <TableRow key={i} hover>
                  {columns.map(c => <TableCell key={c.key}>{orDash(row[c.key])}</TableCell>)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
